import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import HrDashBoardV2 from '@cp/pages/DashboardV2/HrDashBoard';
import { POST_MESSAGE_IDENTIFIER } from '@cp/constants/Global';
import HrDashBoardV3 from './DashboardV3/HrDashBoardV3';
import { ExtensionHandler } from '../utils/extension.utils';
import isLitmusExperimentEnabled from '../utils/isLitmusExperimentEnabled';
import { LITMUS_EXPERIMENT_NAMES } from '../constants/litmusExperimentNames';
import logoutFromAmeyo from '../utils/logoutFromAmeyo';

function HrcRouter() {
  const isHrcV2 = useSelector((store: RootState) => store?.common?.featureFlags?.hrcGrahamBell);

  const [isAmeyoNewIntegrationEnabled, setIsAmeyoNewIntegrationEnabled] = useState(false);
  const agentId = useSelector((state: RootState) => state?.common?.userData?.referenceId);

  useEffect(() => {
    isLitmusExperimentEnabled(LITMUS_EXPERIMENT_NAMES.HRC_AMEYO_V3, {
      'x-customer-id': agentId
    })
      .then(res => {
        if (res?.result) {
          ExtensionHandler.disableExtensionToggle(true);
          logoutFromAmeyo();
          ExtensionHandler.disableAmeyo();
          setIsAmeyoNewIntegrationEnabled(res?.result);
        } else {
          ExtensionHandler.disableExtensionToggle(false);
          ExtensionHandler.enableAmeyo();
        }
      })
      .catch(err => {
        ExtensionHandler.disableExtensionToggle(false);
        ExtensionHandler.enableAmeyo();
      });
  }, []);

  useEffect(() => {
    if (isHrcV2) {
      window.postMessage({
        type: POST_MESSAGE_IDENTIFIER.RECONFIGURE_CLIENT,
        data: 'HRC'
      });
    } else {
      window.postMessage({
        type: POST_MESSAGE_IDENTIFIER.RECONFIGURE_CLIENT,
        data: 'HRC_OLD'
      });
    }
  }, [isHrcV2]);
  if (isHrcV2) {
    if (isAmeyoNewIntegrationEnabled) {
      return <HrDashBoardV3 />;
    }
    return (
      <div>
        <HrDashBoardV2 />
      </div>
    );
  }
  return null;
}

export default HrcRouter;
